import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const GlobalComponentsLoader: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-GlobalComponents" */ './GlobalComponents.tsx'))
			.GlobalComponents,
});
